export const INCIDENT_LCC_STATUS = {
  1: 'รอ LCC บันทึก',
  2: 'รอ ผรม. บันทึก',
  3: 'Close',
}

export const CONFIG_COLOR = {
  0: {
    backgroundColor: '#1890ff',
    color: '#FFFFFF',
  },
  1: {
    backgroundColor: '#FFC53D',
    color: '#000000',
  },
}

export const getEventType = (eventType, alarmType) => {
  switch (eventType) {
    case 3000:
      return 'จอดในจุดห้ามจอด'
    case 1001:
      return 'ความเร็วเกินกำหนด'
    case 7002:
      if (alarmType === 'Continuous') return 'ขับต่อเนื่อง > 4 ชม.'
      if (alarmType === 'Accumulate') return 'ปฏิบัติงาน > 10 ชม./วัน'
      break
    case 1002:
    case 2050:
      return 'ออกตัวกระชาก/เบรคกระทันหัน'
    default:
      return ''
  }
}

// event 7029 (ADAS/DMS/AI) มีหลาย row ใน event_safety แยกกันด้วย alarm_type
// จึงต้อง match ทั้ง event_type + alarm_type ก่อน ถ้าไม่เจอค่อย fallback
// ไปใช้ row ที่ match แค่ event_type (พฤติกรรมเดิมของ event type อื่น)
export const findEventSafety = (eventSafties, eventType, alarmType) => {
  if (!Array.isArray(eventSafties)) return null

  const norm = value =>
    value === null || value === undefined ? '' : String(value)

  const targetEventType = norm(eventType)
  const targetAlarmType = norm(alarmType)

  const byEventType = eventSafties.filter(
    es => norm(es.event_type) === targetEventType,
  )

  if (byEventType.length === 0) return null

  return (
    byEventType.find(es => norm(es.alarm_type) === targetAlarmType) ||
    byEventType[0]
  )
}
